export const methodConstant = [
  { method: 'GET', ID: 'GET', color: '#61affe' },
  { method: 'POST', ID: 'POST', color: '#49cc90'},
  { method: 'PUT', ID: 'PUT', color: '#fca130'},
  { method: 'DELETE', ID: 'DELETE', color: '#f93e3e'},
]
